import superagent from 'superagent'

const Parcels = {
  search: (searchInfo) => {
    const ownerName = `${searchInfo.ownerName}`,
      params = [
        `ownerName=${ownerName}`,
        `ownerState=${searchInfo.ownerState}`,
        `latitude=${searchInfo.latitude}`,
        `longitude=${searchInfo.longitude}`,
        'limit=50'
      ]
    return new Promise((resolve, reject) => {
      superagent
        .get(`${__API_URI__}/Parcel/Search/?${params.join('&')}`)
        .set('Authorization', `Bearer ${searchInfo.token}`)
        .set('Content-Type', 'application/json')
        .set('Platform', 'Web')
        .set('Version', `${__version__}`)
        .end((err, res) => {
          if (err) {
            return reject(err)
          }
          resolve(res.body)
        })
    })
  },

  getExtent: (token, gid) => {
    return new Promise((resolve, reject) => {
      superagent
        .get(`${__API_URI__}/Parcel/Get/${gid}`)
        .set('Authorization', `Bearer ${token}`)
        .set('Content-Type', 'application/json')
        .set('Platform', 'Web')
        .set('Version', `${__version__}`)
        .end((err, res) => {
          if (err) {
            return reject(err)
          }
          resolve(res.body)
        })
    })
  },

  getStateByCoordinates: (lat, lng, token) => {
    return new Promise((resolve, reject) => {
      superagent
        .get(`${__API_URI__}/State/Get/${lat}/${lng}`)
        .set('Authorization', `Bearer ${token}`)
        .set('Content-Type', 'application/json')
        .set('Platform', 'Web')
        .set('Version', `${__version__}`)
        .end((err, res) => {
          if (err || !res?.body) return reject(err)
          resolve(res.body)
        })
    })
  },

  getStates: (token) => {
    return new Promise((resolve, reject) => {
      superagent
        .get(`${__API_URI__}/State/Get/1/`)
        .set('Authorization', `Bearer ${token}`)
        .set('Content-Type', 'application/json')
        .set('Platform', 'Web')
        .set('Version', `${__version__}`)
        .end((err, res) => {
          if (err) {
            return reject(err)
          }
          resolve(res.body)
        })
    })
  }
}

export default Parcels
